<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/login">登陆</router-link> |
      <router-link to="/register">注册</router-link>
    </div> -->
    <navigation>
      <router-view />
    </navigation>
    <!-- <loading v-if="LOADING"/> -->
  </div>
</template>
<script>
export default {
  mounted() {
    // document.body.addEventListener('focusin', () => {
    //   this.bottomFlag = false;
    //   alert(this.bottomFlag)
    //   // 回到原点  若觉得一瞬间回到底部不够炫酷，那自己可以自定义缓慢回弹效果， 可用css 、贝塞尔曲线、js的 requestAnimationFrame  等等 方法 实现体验性更好的回弹效果
    //   // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    // })
    // document.body.addEventListener('focusout', () => {
    //   // this.bottomFlag = true;
    //   // 回到原点  若觉得一瞬间回到底部不够炫酷，那自己可以自定义缓慢回弹效果， 可用css 、贝塞尔曲线、js的 requestAnimationFrame  等等 方法 实现体验性更好的回弹效果
    //   // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    //   const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    //   window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    // })
  }
}
// import {mapState} from 'vuex'
// export default {
//   computed:{
//       ...mapState([
//           'LOADING'
//       ])
//   },
//   name: 'App'
// }
</script>
<style lang="stylus">
@require "/color.styl"


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  min-height: -webkit-fill-available;
  background:rgba(248,248,248,1);
}

#app input:-internal-autofill-selected {
  background-color: #fff !important;
}

img {
  object-fit: cover;
}

body {
  font-size: 14px !important;
  -webkit-overflow-scrolling: touch;
	overflow-scrolling: touch;
	overflow-y: scroll;
}
* {
  -webkit-tap-highlight-color: transparent;
}
html, body {
  height: -webkit-fill-available
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.red-button {
  background: $color-button !important;
}

.red-button:active {
  background: #fab6b6 !important;
}

.red-font {
  color: $color-button;
}
.button{
  -webkit-appearance: none !important;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border: none;
  text-decoration: none;
  background:$color-button !important;
}
.button:active{
  background-color:#c0141b !important;
}
.cube-btn_disabled {
  background-color:#fab6b6 !important;
}
.display-flex {
  display: -webkit-flex;
  display: flex;
}

.cube-input-field {
  color: #333;
}
.cube-toast-tip {
  max-height: 200px;
}

.cube-input input {
  padding-right: 8px !important;
}

.cube-checkbox_checked .cube-checkbox-ui i {
  color: $color-button !important;
}

.cube-checkbox-label {
  display: none;
}
</style>
